<template>
  <AutoSuggest
    v-model="countriesRestrictions"
    class="mb-0"
    :label="
      $t(
        '_android_competition_details_info_allowed_countries',
        'Allowed countries:'
      )
    "
    :disabled="isTournamentFieldDisabled('countries_restrictions')"
    multiple
    only-unique
    :source="suggestCountriesRequest"
    name="countryRestriction"
    :placeholder="$$t('Add Countries...', 'country-restriction-placeholder')"
    :tooltip="
      $$t(
        'Only participants from listed country will be allowed to register',
        'country-restriction-tooltip'
      )
    "
    display-property="text"
  />
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AutoSuggest from '@/components/molecules/form/autoComplete/HeraAutosuggest';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentCountriesRestrictionSetting',
  components: {
    AutoSuggest,
  },
  mixins: [translate('_web_tournament_additional_settings')],

  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    countriesRestrictions: {
      get() {
        const countries = this.$lodash.get(
          this.currentTournament,
          'restrictions.countries_restrictions',
          null
        );
        return countries
          ? countries.map(el => ({
              id: el.id,
              text: el.name,
            }))
          : null;
      },
      set(newVal) {
        if (Array.isArray(newVal)) {
          this.updateCurrentTournament({
            countries_restrictions: newVal.map(el => ({
              id: el.id,
              name: el.text,
            })),
            component: 'restrictions',
          });
        } else if (!newVal) {
          this.updateCurrentTournament({
            countries_restrictions: null,
            component: 'restrictions',
          });
        }
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    ...mapActions(['suggestCountriesRequest']),
  },
};
</script>
